/* ============
 * Actions for the reminder module
 * ============
 *
 * The actions that are available on the
 * reminder module.
 */
import Vue from 'vue';

import eventBus from '@/plugins/event-bus';
import message from '@/constants/_message';
import EVENTS from '@/constants/_events';
import ReminderProxy from '@/proxies/ReminderProxy';
import types from './mutation-types';

export const getReminders = ({
  commit
}, data) => {
  commit(types.FETCH_REMINDER_LIST);
  new ReminderProxy().getReminders(data)
    .then(({
      totalCount,
      assessmentReminders
    }) => {
      commit(types.FETCH_REMINDER_LIST_SUCCESS, {
        totalCount,
        assessmentReminders
      });
    }).catch((error) => {
      commit(types.FETCH_REMINDER_LIST_FAIL, error);
    });
};

// Adding Reminders

export const createReminder = ({ commit }, data) => {
  commit(types.CREATE_REMINDER);
  new ReminderProxy().createReminder(data).then((response) => {
    commit(types.CREATE_REMINDER_SUCCESS, response);
    // assessmentReminders = { ...response }
    // Vue.router.push({
    //   name: 'careplan.view',
    //   params: { id: response.careplan.id }
    // });
    eventBus.$emit(EVENTS.RELOAD_REMINDERS);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.REMINDER_CREATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.CREATE_REMINDER_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: error.error.message,
      type: 'error'
    });
  });
};

export const updateReminder = ({ commit }, data) => {
  commit(types.UPDATE_REMINDER);
  new ReminderProxy().updateReminder(data).then((response) => {
    commit(types.UPDATE_REMINDER_SUCCESS, response);
    eventBus.$emit(EVENTS.RELOAD_REMINDERS);
    Vue.router.push({
      name: 'patientProgress.index',
      params: { id: response.id }
    });
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.UPDATE_REMINDER,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.UPDATE_REMINDER_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.REMINDER_NOT_UPDATED,
      type: 'error'
    });
  });
};

export default {
  getReminders,
  createReminder,
  updateReminder
};
